import { render, staticRenderFns } from "./FormTextareaField.vue?vue&type=template&id=3acac4c6"
import script from "./FormTextareaField.vue?vue&type=script&lang=ts"
export * from "./FormTextareaField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports